import styled from 'styled-components';

const PatientPageWrapper = styled.div`
  @media (min-width: 1051px) {
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export default PatientPageWrapper;
